export const SET_BANK_DATA = 'SET_BANK_DATA';
